import { CurrencyToSign } from '@monorepo/client-types';
import {
  Application,
  CartType,
  OptionalAssets,
  SupportedCurrencies,
} from '@monorepo/types';

export const getFilteredActiveAssets = (
  activeAssets: OptionalAssets[],
  project: Application,
): OptionalAssets[] => {
  if (project === Application.TTP) {
    return activeAssets.filter(
      (asset) =>
        asset === OptionalAssets.DayTrade || asset === OptionalAssets.Swing,
    );
  }
  if (project === Application.THE5ERS) {
    return activeAssets.filter(
      (asset) =>
        asset === OptionalAssets.Forex || asset === OptionalAssets.Futures,
    );
  }
  return [];
};

export const getAssetItemCount = (
  cart: CartType,
  asset: OptionalAssets,
): number => {
  return cart[asset]?.items?.length || 0;
};

export const getCurrencySign = (currency: SupportedCurrencies) =>
  currency ? CurrencyToSign[currency] : CurrencyToSign[SupportedCurrencies.USD];
